import type {ActionSpec, ActionStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const GetContactInputSchema = z.object({
  identifier: z.string(), // email or id
});
export type GetContactInput = z.infer<typeof GetContactInputSchema>;

export const GetContactOutputSchema = z.object({
  contact: z
    .object({
      id: z.number(),
      email: z.string().optional(),
      emailBlacklisted: z.boolean(),
      smsBlacklisted: z.boolean(),
      createdAt: z.string(),
      modifiedAt: z.string(),
      listIds: z.array(z.number()),
      listUnsubscribed: z.array(z.number()).nullable().optional(),
      attributes: z.record(z.string(), z.unknown()),
    })
    .nullable(),
});
export type GetContactOutput = z.infer<typeof GetContactOutputSchema>;

export type GetContactActionStruct = ActionStruct<'get-contact', GetContactInput, GetContactOutput>;
export const GetContactActionSpec: ActionSpec<GetContactActionStruct> = {
  id: 'get-contact',
  inputSchema: GetContactInputSchema,
  outputSchema: GetContactOutputSchema,
};
